import { ClienteService } from 'app/service/cliente/cliente.service';
import { CaixaService } from './../../../service/caixa/caixa.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnDestroy, OnInit } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { EventEmitterService } from 'app/service/event-emitter-service';

@Component({
  selector: 'app-relatorio-caixas-selecionadas',
  templateUrl: './relatorio-caixas-selecionadas.component.html',
  styleUrls: ['./relatorio-caixas-selecionadas.component.scss']
})
export class RelatorioCaixasSelecionadasComponent implements OnInit, OnDestroy {

  arrayIds;
  deData;
  nomeEmpresa;
  idEmpresa;
  idEmpresaNumber;
  loading = true;
  caixas: any[] = [];
  dateTime;

  constructor(private route: ActivatedRoute,
    private caixaService: CaixaService,
    private clienteService: ClienteService) {
    EventEmitterService.get("isPrintPage").emit(true);
    this.route.params.subscribe(params => this.arrayIds = params['ids']);
    this.deData = CryptoJS.AES.decrypt(decodeURIComponent(this.arrayIds), 'pcdoc');
    this.arrayIds = JSON.parse(this.deData.toString(CryptoJS.enc.Utf8));
    this.route.params.subscribe(params => this.idEmpresa = params['empresa']);
   }

  ngOnInit() {
    this.idEmpresaNumber = parseInt(this.idEmpresa);
    this.getCaixas(this.arrayIds);
    this.getNomeEmpresa(this.idEmpresaNumber);

    let date = new Date();
    this.dateTime = date.toLocaleString('pt-BR');
  }

  ngOnDestroy() {
    EventEmitterService.get("isPrintPage").emit(false);
  }

  getCaixas(ids) {
    this.caixaService.relatorioCaixas(ids).subscribe(data => {
      this.caixas = data;
      this.loading = false;
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }

  getNomeEmpresa(id) {
    this.clienteService.nomeCliente(id).subscribe(data => {
      this.nomeEmpresa = data;
    }, err => {
      console.error(err);
      this.nomeEmpresa = err.error.text;
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/caixa/relatorio-caixas-selecionadas/relatorio-caixas-selecionadas.component.ts